import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { from, map, switchMap } from "rxjs";
import { liveLessonAuthActions } from "@pcp/auth";
import { StreamingHubService } from "@pcp/streaming";
import { classroomConnectionActions } from "shared/classroom/data-access";

@Injectable()
export class ConnectSignalrEffects {

    readonly connectToSignalrAfterLogin$ = createEffect(() => this.actions$.pipe(
        ofType(
            liveLessonAuthActions.userLoginSuccess,
            liveLessonAuthActions.tokenRestoreSuccess,
        ),
        switchMap(action => from(this.signalR.startConnection()).pipe(
            map(() => classroomConnectionActions.connectToClassroom({ lessonId: action.tokenData.claims.lessonId! }))
        )),
    ));

    constructor(
        private readonly actions$: Actions,
        private readonly signalR: StreamingHubService,
    ) {}
}
